import { NavLink, generatePath } from 'react-router-dom';
import { IconLoader, PermissionDenied, PermissionEnum } from '@ui/src';
import ROUTES from '../../routes';
import { ColumnAccountsTypes } from './types';
import ColumnHead from './column-head';

import cn from './column.module.css';

const ColumnAccounts = ({
  accounts,
  bankId,
  isLoading,
  onClick,
  activePermissions,
  scrollRef,
  onScroll,
  isFetching,
  nextPageIsLoading,
}: ColumnAccountsTypes): React.JSX.Element => {
  let content;

  if (isLoading || (isFetching && !nextPageIsLoading)) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else if (!activePermissions?.includes(PermissionEnum.PSP_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = accounts?.map((item) => (
      <div className={cn.columnItemWrapper} key={item.id}>
        <NavLink
          className={`${cn.columnItem} ${item.isNew ? cn.badge : ''}`}
          to={generatePath(ROUTES.EXPORT_ACCOUNTS, {
            bankId: bankId as string,
            accountId: item.id,
          })}
          onClick={() => onClick(item.id, item.name)}
        >
          {item.name}
        </NavLink>
      </div>
    ));
  }

  return (
    <div
      className={cn.column}
      ref={scrollRef}
      onScroll={onScroll ? (e) => onScroll(e) : undefined}
    >
      <ColumnHead title="Accounts" />

      {content}
      {nextPageIsLoading && (
        <div className={cn.nextPageLoader}>
          <IconLoader width={22} height={22} />
        </div>
      )}
    </div>
  );
};

export default ColumnAccounts;
